import { render, staticRenderFns } from "./MetadataPanel.vue?vue&type=template&id=7778a03e&"
import script from "./MetadataPanel.vue?vue&type=script&lang=js&"
export * from "./MetadataPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports